"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scale_1 = require("../../utils/scale");
const react_native_1 = require("react-native");
// import { min } from "lodash";
const react_1 = __importStar(require("react"));
const react_zoom_pan_pinch_1 = require("react-zoom-pan-pinch");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const icons_1 = require("../../assets/icons");
const IC_ARROW_LEFT_1 = __importDefault(require("../../assets/icons/IC_ARROW_LEFT"));
const IC_ARROW_RIGHT_1 = __importDefault(require("../../assets/icons/IC_ARROW_RIGHT"));
const images_1 = require("../../assets/images");
const helpler_1 = require("../../utils/helpler");
const ModalViewImage = (props) => {
    const { visible, onClose, data, index = 0 } = props;
    const { width: _width, height } = react_native_1.Dimensions.get('window');
    const width = react_native_1.Platform.OS === 'web' ? (_width >= 1024 ? 375 : _width) : _width;
    const [numberIndex, setNumberIndex] = (0, react_1.useState)(index);
    const [background, setBackground] = (0, react_1.useState)(false);
    const isPNGImage = (url) => {
        return /\.png$/i.test(url);
    };
    (0, react_1.useEffect)(() => {
        setNumberIndex(index);
    }, [index]);
    (0, react_1.useEffect)(() => {
        if (isPNGImage(data[numberIndex]?.url)) {
            setBackground(true);
        }
        else {
            setBackground(false);
        }
    }, [numberIndex]);
    const widthImage = () => {
        if (data?.length == 1) {
            return 0;
        }
        else if (data?.length > 1) {
            if (numberIndex == 0) {
                return (0, scale_1.scale)(40);
            }
            else if (data?.length > numberIndex + 1) {
                return (0, scale_1.scale)(80);
            }
            else {
                return (0, scale_1.scale)(40);
            }
        }
        return 0;
    };
    const widthMarginleft = () => {
        if (data?.length == 1) {
            return 0;
        }
        else if (data?.length > 1) {
            if (numberIndex == 0) {
                return (0, scale_1.scale)(0);
            }
            else if (data?.length > numberIndex + 1) {
                return (0, scale_1.scale)(40);
            }
            else {
                return (0, scale_1.scale)(40);
            }
        }
        return 0;
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: () => {
            onClose(), setNumberIndex(index);
        }, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                onClose(), setNumberIndex(index);
            }, style: {
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                // left: -widthImage()
            } }, (react_1.default.createElement(react_native_1.ImageBackground, { source: images_1.images?.BackGroundPng, style: {
                backgroundColor: '#000',
                position: 'relative',
                width: width,
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: width + widthImage(),
                    left: -widthMarginleft(),
                } },
                numberIndex != 0 && data?.length > 1 && (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        backgroundColor: numberIndex == 0 ? undefined : 'rgba(0, 0, 0, 0.75)',
                        height: (0, scale_1.scale)(40),
                        width: (0, scale_1.scale)(40),
                        left: (0, scale_1.scale)(40),
                        borderRadius: 99,
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1,
                    }, onPress: () => setNumberIndex(numberIndex - 1), disabled: numberIndex == 0 },
                    react_1.default.createElement(IC_ARROW_LEFT_1.default, null))),
                react_1.default.createElement(react_zoom_pan_pinch_1.TransformWrapper, { smooth: true },
                    react_1.default.createElement(react_zoom_pan_pinch_1.TransformComponent, null,
                        react_1.default.createElement(react_native_1.Image, { source: data[numberIndex]?.url || images_1.images?.NoImages, style: { width, height }, resizeMode: "contain" }))),
                data?.length > numberIndex + 1 && data?.length > 1 && (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        backgroundColor: data?.length == numberIndex + 1
                            ? undefined
                            : 'rgba(0, 0, 0, 0.75)',
                        height: (0, scale_1.scale)(40),
                        width: (0, scale_1.scale)(40),
                        right: (0, scale_1.scale)(40),
                        borderRadius: 99,
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1,
                    }, onPress: () => setNumberIndex(numberIndex + 1), disabled: data?.length == numberIndex + 1 }, data?.length > numberIndex + 1 && react_1.default.createElement(IC_ARROW_RIGHT_1.default, null))),
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.header,
                        { left: numberIndex == 0 ? (0, scale_1.scale)(16) : (0, scale_1.scale)(56) },
                    ] },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                            onClose(), setNumberIndex(index);
                        }, style: {
                            height: (0, scale_1.scale)(30),
                            width: (0, scale_1.scale)(30),
                            borderRadius: 99,
                            backgroundColor: 'black',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(icons_1.IC_X, { width: (0, scale_1.scale)(24), height: (0, scale_1.scale)(24), color: "#FFFFFF" })))))))));
};
const styles = react_native_1.StyleSheet.create({
    mainNoti: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors_1.default.textHeaderOpacity60,
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: (0, scale_1.scale)(16),
    },
    circle: {
        height: (0, scale_1.scale)(18),
        width: (0, scale_1.scale)(18),
        borderRadius: 99,
        marginRight: 10,
        borderWidth: 1,
        borderColor: '#C8C8C8',
    },
    checkedCircle: {
        backgroundColor: '#007AFF',
        width: (0, scale_1.scale)(8),
        height: (0, scale_1.scale)(8),
        borderRadius: 99,
        marginLeft: (0, scale_1.scale)(4),
        marginTop: (0, scale_1.scale)(4)
    },
    btn: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#DDDDDD',
        height: (0, scale_1.scale)(48),
    },
    textBtn: {
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        fontWeight: 'bold',
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: '100%',
        borderTopWidth: 1,
        borderTopColor: '#CCCCCC',
        flexDirection: 'row',
    },
    header: {
        position: 'absolute',
        top: 0,
        right: 0,
        flexDirection: 'row',
        paddingTop: (0, scale_1.scale)(16),
        zIndex: 1,
    },
    textCheck: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        fontWeight: '300',
        color: '#292A33',
    },
    textDetail: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        fontWeight: '300',
        color: '#7C7C7C',
    },
    err: {
        color: '#FF0000',
        fontSize: (0, scale_1.moderateScale)(13),
        marginBottom: (0, scale_1.scale)(10),
    },
});
exports.default = ModalViewImage;
